"use strict";
/*******************************************************************************

    Contains definition for the validator

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
var Hash_1 = require("../../common/Hash");
var Utils_1 = require("../../utils/Utils");
var PreImage_1 = require("./PreImage");
/**
 * Define the validator
 */
var Validator = /** @class */ (function () {
    /**
     * Constructor
     * @param address The public key that is included in the frozen UTXO.
     * @param height  The block height when enrolled
     * @param stake   The hash of frozen UTXO
     * @param image   The pre-image
     */
    function Validator(address, height, stake, image) {
        if (address !== undefined)
            this.address = address;
        else
            this.address = "";
        if (height !== undefined)
            this.enrolled_at = height;
        else
            this.enrolled_at = 0;
        if (stake !== undefined)
            this.stake = stake;
        else
            this.stake = Hash_1.Hash.Null;
        if (image !== undefined)
            this.preimage = image;
        else
            this.preimage = new PreImage_1.PreImage();
    }
    /**
     * This import from JSON
     * @param data The object of the JSON
     */
    Validator.prototype.fromJSON = function (data) {
        Utils_1.Utils.validateJSON(this, data);
        this.address = data.address;
        this.enrolled_at = data.enrolled_at;
        this.stake.fromString(data.stake);
        this.preimage.fromJSON(data.preimage);
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=Validator.js.map